import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

const COLOR = { entregado: "bg-emerald-600 text-white", en_ruta: "bg-blue-600 text-white" };
const ROJO = "bg-red-600 text-white";

/** Hoja de Pedidos (departamento): alertas de colocación y entrega por paquete. */
export const ColResumenAlertas = ({ o }) => {
  const c = o.col_resumen;
  if (!c || !c.total) return null;
  const faltaColocar = c.total - c.colocados;
  const faltaEntregar = c.total - c.entregados;
  return (
    <>
      {faltaColocar > 0 && (
        <div className="mt-1 rounded bg-orange-500 text-white text-[11px] font-black uppercase leading-tight px-1.5 py-1" data-testid={`alerta-colocar-${o.numero}`}>
          Paquetes pendientes de colocar: {faltaColocar} de {c.total}
        </div>
      )}
      {c.colocados > 0 && (faltaEntregar > 0
        ? <div className="mt-1 rounded bg-black text-white text-[11px] font-black uppercase leading-tight px-1.5 py-1" data-testid={`alerta-entregar-${o.numero}`}>Pendientes de entregar: {faltaEntregar} de {c.total}</div>
        : <div className="mt-1 rounded bg-emerald-700 text-white text-[11px] font-black uppercase leading-tight px-1.5 py-1" data-testid={`alerta-entregados-${o.numero}`}>Todos los paquetes entregados</div>)}
    </>
  );
};

/** Hoja de Pedidos: resumen compacto de guías por estado; clic = ventana con cada guía. */
export const GuiasSeg = ({ o }) => {
  const gs = o.guias_seg || [];
  if (!gs.length) return null;
  const cnt = {};
  gs.forEach((g) => { cnt[g.estado_lbl] = (cnt[g.estado_lbl] || 0) + 1; });
  const txt = Object.entries(cnt).map(([l, n]) => `${n} ${l.toLowerCase()}${n > 1 && !l.includes(" ") ? "s" : ""}`).join(", ");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="mt-0.5 block w-full text-left text-[9px] leading-tight text-[#002FA7] font-semibold underline decoration-dotted" title={txt} data-testid={`guias-seg-${o.numero}`}>
          {gs.length} guía{gs.length === 1 ? "" : "s"}: {txt}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3" align="start" data-testid={`guias-seg-pop-${o.numero}`}>
        <div className="text-xs font-black uppercase text-zinc-500 mb-2">{o.numero} · {gs.length} guía(s)</div>
        <div className="space-y-1.5 max-h-64 overflow-y-auto">
          {gs.map((g) => (
            <div key={g.guia} className="flex items-center justify-between gap-2" data-testid={`guias-seg-item-${g.guia}`}>
              <span className="font-mono text-sm font-bold break-all">{g.guia}</span>
              <span className="text-right">
                <span className={`text-[10px] font-black uppercase px-1.5 py-0.5 rounded ${COLOR[g.estado] || ROJO}`}>{g.estado_lbl}</span>
                {g.at && <span className="block text-[9px] text-zinc-500">{g.at}</span>}
              </span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
